// extracted by mini-css-extract-plugin
export default {"wrapper":"loading__wrapper"};